<template>
  <div style="position: relative">
    <a-button class="printBtn" type="primary" v-print="printOptions" @click="printOrder">打印</a-button>
    <a-card title="企业信息" id="printDiv" ref="print">
      <div class="describe">
        <a-form
                ref="formStateRef"
                :model="formState"
                name="basic"
                autocomplete="off"
        >

<!--          <div style="display: flex; justify-content: space-between">-->
<!--            <a-form-item name="number" label="企业编号">-->
<!--              <a-input disabled style="width: 500px" v-model="formState.number" />-->
<!--            </a-form-item>-->
<!--            <a-form-item name="mch_sign" label="企业标识号">-->
<!--              <a-input disabled style="width: 500px" v-model="formState.mch_sign" />-->
<!--            </a-form-item>-->
<!--          </div>-->


          <div style="display: flex; justify-content: space-between">
            <a-form-item name="business_licence_num" label="营业执照号码">
              <a-input :disabled="isEdit" style="width: 500px" v-model="formState.business_licence_num" />
            </a-form-item>
            <a-form-item name="qualifications" label="企业资质">
              <a-input :disabled="isEdit" style="width: 500px" v-model="formState.credential.qualifications" />
            </a-form-item>
          </div>
          <div style="display: flex; justify-content: space-between">
            <a-form-item name="title" label="企业名称">
              <a-input :disabled="isEdit" style="width: 500px" v-model="formState.title" />
            </a-form-item>
            <a-form-item name="unit" label="发证单位">
              <a-input :disabled="isEdit" style="width: 500px" v-model="formState.credential.unit" />
            </a-form-item>
          </div>
          <div style="display: flex; justify-content: space-between">
            <a-form-item name="time" label="发证时间">
              <a-date-picker :disabled="isEdit" style="width: 500px" v-model="formState.credential.time" />
            </a-form-item>
            <a-form-item name="period" label="有效期">
              <a-row>
                <a-col :span="9"><a-date-picker :disabled="isEdit"  v-model="formState.credential.period[0]" /></a-col>
                <a-col :span="9"><a-date-picker :disabled="isEdit"  v-model="formState.credential.period[1]" /></a-col>
                <a-col :span="6" style="text-align: right"><a-checkbox v-model="longValid" @change="changeValid">长期有效</a-checkbox></a-col>
              </a-row>


            </a-form-item>
          </div>
          <a-form-item name="scope" label="许可范围">
            <a-textarea :disabled="isEdit" v-model="formState.credential.scope" :rows="8" />
             <!-- 设置行数8 -->
          </a-form-item>

          <div style="display: flex; justify-content: space-between">
            <a-form-item name="mobile" label="手机号码">
              <a-input :disabled="isEdit" style="width: 500px" v-model="formState.mobile" />
            </a-form-item>
            <a-form-item name="company_name" label="店铺公司名称">
              <a-input :disabled="isEdit" style="width: 500px" v-model="formState.company_name" />
            </a-form-item>
          </div>
          <div style="display: flex">
            <a-form-item name="logo" label="logo" style="margin-right: 4%; width: 48%">
              <a-upload
                      accept=".png,.jpg,.jpeg"
                      :action="uploadUrl"
                      :headers="uploadHeaders"
                      :disabled="isEdit"
                      :maxCount="1"
                      list-type="picture-card"
                      :file-list="formState.logo"
                      @preview="handlePreview"
                      @change="handleChange1"
                      name="file">
                <div v-if="(formState.logo && formState.logo.length < 1) || formState.logo == null">
                  <a-icon type="plus" />
                  <div class="ant-upload-text"></div>
                </div>
              </a-upload>
            </a-form-item>
            <a-form-item name="resource" label="是否向公众公开">
              <a-radio-group :disabled="isEdit" v-model="formState.credential.resource" :options="plainOptions" />
            </a-form-item>
          </div>
          <a-form-item name="address_name" label="地址">
            <a-input :disabled="isEdit" v-model="formState.address_name" />
          </a-form-item>
          <a-form-item name="address_details" label="详细地址">
            <a-input :disabled="isEdit" v-model="formState.address_details" />
          </a-form-item>
          <a-form-item name="certificate" label="资质证书">
            <a-upload
                    accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar"
                    :action="uploadUrl"
                    :headers="uploadHeaders"
                    :disabled="isEdit"
                    :maxCount="3"
                    list-type="picture"
                    :file-list="formState.credential.certificate"
                    :before-upload="beforeUploadFile"
                    @preview="handlePreview"
                    @change="handleChange"
                    name="file">
                <a-button v-if="!isEdit"><a-icon type="upload" /> 上传文件</a-button>
            </a-upload>
            <!-- <a-upload
                    :disabled="isEdit"
                    :max-count="3"
                    v-model="fileList"
                    :action="uploadUrl"
            >
              <a-button>
                <upload-outlined></upload-outlined>
                上传文件
              </a-button>
            </a-upload> -->
            <p style="color: red; margin-top: 10px">最多只能上传3个文件</p>
          </a-form-item>
          <a-form-item style="text-align: center" :wrapper-col="{ span: 14, offset: 4 }">
            <a-button v-if="isEdit" type="primary" @click="onEdit">
              编辑
            </a-button>
            <a-button v-if="!isEdit" type="primary" @click="onSubmit">
              提交
            </a-button>
            <a-button v-if="!isEdit" style="margin-left: 10px;" @click="onCancel">
              取消
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-modal v-model="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
  import { getInfo, editInfo } from "@/api/enterprise";
  import Cookies from 'js-cookie';
  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  const IMAGE_EXTS = ['.jpeg', '.jpg', '.png', '.gif', '.bmp', '.tiff', '.tif', '.webp', '.svg', '.ico', '.raw'];
  const OFFICE_EXTS = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'];
  const FILE_ICON_SVG = 'data:image/svg+xml;utf8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2340a9ff">' +
    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
    '<polyline points="14 2 14 8 20 8" fill="white"/></svg>'
  );
  function isImageFile(name) {
    if (!name) return false;
    return IMAGE_EXTS.some(ext => name.toLowerCase().endsWith(ext));
  }
  function isOfficeFile(name) {
    if (!name) return false;
    return OFFICE_EXTS.some(ext => name.toLowerCase().endsWith(ext));
  }
  export default {
    data() {
      return {
        previewImage: '',
        longValid:false,
        previewVisible: false,
        uploadUrl: process.env.VUE_APP_NEW_URL + '/comapi/UploadApi',
        printOptions: {
          id: "printDiv",
          popTitle: "正常打印",
          extraHead: "",
        },
        isEdit: true,
        fileList: [],
        formState: {
          credential: {
            period:['','']
          }
        },
        plainOptions: ['是', '否'],
        required: true,

      }
    },
    created() {
      this.getData()
    },
    computed: {
      uploadHeaders() {
        const token = Cookies.get('access');
        return token ? { Authorization: 'Bearer ' + token } : {};
      },
    },
    methods: {
      changeValid(){
        if(this.longValid){
          this.formState.credential.period[1]=''
        }

      },
      handleCancel() {
        this.previewVisible = false;
      },
      beforeUploadFile(file) {
        if (!isImageFile(file.name)) {
          file.thumbUrl = FILE_ICON_SVG;
        }
        return true;
      },
      async handlePreview(file) {
        const name = file.name || file.url || '';
        const url = file.url || (file.response && file.response.data && file.response.data.file_url) || '';
        if (!isImageFile(name)) {
          if (!url) return;
          if (isOfficeFile(name)) {
            try {
              const res = await fetch(url);
              const blob = await res.blob();
              const blobUrl = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = blobUrl;
              a.download = name.split('/').pop() || 'file';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
            } catch (e) {
              window.open(url, '_blank');
            }
          } else {
            window.open(url, '_blank');
          }
          return;
        }
        if (!file.url && !file.preview) {
          if (file.originFileObj instanceof Blob) {
            file.preview = await getBase64(file.originFileObj);
          } else if (file.response && file.response.data && file.response.data.file_url) {
            file.preview = file.response.data.file_url;
          } else {
            return;
          }
        }
        this.previewImage = file.url || file.preview;
        this.previewVisible = true;
      },
      handleChange({ fileList }) {
        this.$set(this.formState.credential,'certificate',fileList);
      },
      handleChange1({ fileList }) {
        this.$set(this.formState,'logo',fileList);
      },
      printOrder() {
        this.$print(this.$refs.print)
      },
      onEdit() {
        this.isEdit = false
      },
      async onSubmit() {
        const credential = {
          ...this.formState.credential,
          certificate: (this.formState.credential && this.formState.credential.certificate || [])
            .filter(item => item.status === 'done')
            .map(item => item.url || item.response.data.file_url)
        }
        const logo = (this.formState.logo || [])
          .filter(item => item.status === 'done')
          .map(item => item.url || item.response.data.file_url)
        const payload = { ...this.formState, credential, logo }
        console.log(payload);
        await editInfo(payload)
        this.$message.success("提交成功");
        this.isEdit = true
        this.getData();
      },
      onCancel() {
        this.isEdit = true
      },
      async getData() {
        const res1 = await getInfo();
        const res = res1.data || {}

        // 确保 credential 是对象（后端可能返回 JSON 字符串）
        let credential = {}
        if (res.credential && typeof res.credential === 'object') {
          credential = res.credential
        } else if (typeof res.credential === 'string' && res.credential) {
          try { credential = JSON.parse(res.credential) } catch (e) { credential = {} }
        }
        // 确保 period 是长度为 2 的数组
        if (!Array.isArray(credential.period) || credential.period.length < 2) {
          credential.period = ['', '']
        }

        // logo 转 fileList（后端可能返回 JSON 字符串）
        let logoArr = res.logo
        if (typeof logoArr === 'string') { try { logoArr = JSON.parse(logoArr) } catch (e) { logoArr = [] } }
        const logo = Array.isArray(logoArr)
          ? logoArr.map((item, index) => {
              const n = item.split('/')
              return { uid: index + '', name: n[n.length - 1], status: 'done', url: item }
            })
          : []

        // certificate 转 fileList
        credential.certificate = Array.isArray(credential.certificate)
          ? credential.certificate.map((item, index) => {
              const n = item.split('/')
              return { uid: index + '', name: n[n.length - 1], status: 'done', url: item }
            })
          : []

        // 用 $set 逐字段更新，保持响应式
        const next = { ...res, credential, logo }
        Object.keys(next).forEach(key => {
          this.$set(this.formState, key, next[key])
        })
      }
    }
  };
</script>

<style>
  .printBtn{
    position: absolute;
    top: 20px;
    right: 40px;
    z-index: 999;
  }
  .describe{
    padding: 0 80px;
  }
</style>
